module.exports = __webpack_public_path__ + "onboarding5.png";